import * as React from "react";
import { forwardRef } from "react";
const SvgFolderIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 22 16", style: {
  enableBackground: "new 0 0 22 16"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", { points: "11.2,0 8.3,3 0,3 0,16 22,16 22,0  " }), /* @__PURE__ */ React.createElement("rect", { width: 8, height: 2 })));
const ForwardRef = forwardRef(SvgFolderIcon);
export { ForwardRef as ReactComponent };
